import { action } from 'satcheljs';

/**
 * The action to set the personal booking button label on calendar left pane
 */
let setBookingPageSetupStatus = action(
    'setBookingPageSetupStatus',
    (hasPersonalBookingSetUp: boolean) => ({
        hasPersonalBookingSetUp,
    })
);

export default setBookingPageSetupStatus;
